import { Routes } from '@angular/router';
import { IntermediateCommunicationFormComponent } from './components/intermediate-communication-form/intermediate-communication-form.component';
import { LoginComponent } from './components/login/login.component';
import { ServiceConfigComponent } from './components/service-config/service-config.component';
import { authGuard } from './guards/auth.guard';
import { IncidentCommunicationsComponent } from './components/incident-communications/incident-communications.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'service-config',
    component: ServiceConfigComponent,
    canActivate: [authGuard],
  },
  {
    path: 'communications-form',
    component: IntermediateCommunicationFormComponent,
    canActivate: [authGuard],
  },
  {
    path: 'incident-communications',
    component: IncidentCommunicationsComponent,
    canActivate: [authGuard],
  },
  {
    path: '**',
    redirectTo: 'incident-communications',
  }
];
